export const SHOP_SESSION_PROP_NAME = 'shopSessionId'
export const SHOP_SESSION_COOKIE_NAME = '_HEDVIG_SHOP_SESSION'
export const SHOP_SESSION_COOKIE_MAX_AGE = 30 * 24 * 3600
